import SiafLiteApiRepository from "../../external/siafLiteApi";

class EventosFiscaisService {
  constructor() {
    this.urlBase = "/faturamento/eventos-fiscais";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  cancelar(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/cancelar`
    ).get();
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }
}

export default EventosFiscaisService;
